import { createSlice } from "@reduxjs/toolkit";
import { addAuthor, editAuthor, getAuthor, getAuthorList } from "../services/author-services";


const initialState = {
  authors: [],
  author: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const authorSlice = createSlice({
  name: "author",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthorList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAuthorList.fulfilled, (state, action) => {
        state.authors = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getAuthorList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAuthor.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAuthor.fulfilled, (state, action) => {
        state.authors = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getAuthor.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addAuthor.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addAuthor.fulfilled, (state, action) => {
        state.authors = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addAuthor.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editAuthor.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editAuthor.fulfilled, (state, action) => {
        state.authors = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editAuthor.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = authorSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default authorSlice.reducer;
